import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/student/appraise/icon.png'
import _imports_1 from '@/assets/student/appraise/sad.png'
import _imports_2 from '@/assets/student/appraise/smile.png'
import _imports_3 from '@/assets/student/appraise/deadline.png'
import _imports_4 from '@/assets/student/appraise/finish.png'
import _imports_5 from '@/assets/student/appraise/exclude.png'


const _withScopeId = n => (_pushScopeId("data-v-18c7df26"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "txt-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " 当前您评价的是 ", -1))
const _hoisted_5 = { class: "text-small" }
const _hoisted_6 = {
  key: 1,
  class: "content"
}
const _hoisted_7 = {
  key: 0,
  class: "appraise-remark"
}
const _hoisted_8 = {
  key: 0,
  class: "question-remark"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "mock-checkbox" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"extra-face\" data-v-18c7df26><div class=\"extra-face-item\" data-v-18c7df26><img class=\"smile-icon\" src=\"" + _imports_1 + "\" data-v-18c7df26><div class=\"txt\" data-v-18c7df26> 不满意 </div></div><div class=\"extra-face-item\" data-v-18c7df26><img class=\"smile-icon\" src=\"" + _imports_2 + "\" data-v-18c7df26><div class=\"txt\" data-v-18c7df26> 非常满意 </div></div></div>", 1)
const _hoisted_13 = {
  key: 2,
  class: "btn-block"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 提交评价 ")
const _hoisted_15 = {
  key: 3,
  class: "unfill"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "img-deadline"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "img-desc" }, " 评价已截止 ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted mt-20" }, " 期待下次收到你的评价 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "img-finish"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "img-desc" }, " 评价已完成 ")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted mt-20" }, " 期待你的下次评价 ", -1))
const _hoisted_20 = {
  key: 2,
  class: "img-wrap"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "img-exclude"
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-desc" }, " 当前评价无需参与 ", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

import { RadioGroup, Radio, Field, Button, Toast } from "vant";
import { getEvaluationInfo, submitEvaluationInfo } from "@/api/appraise"
import { reactive, onMounted, } from 'vue';
import { useRoute } from "vue-router";
interface IAppraiseData {
  id: number;
  name?: string;
  taskStatus?: number;
  expiration?: boolean;
  questionList?: Array<IQuestionItem>;
  evaluationRemark?: string;
}
interface IQuestionItem {
  id: number;
  questionType: 1 | 2 | 3;//1待评价 2已评价 3已过期
  questionContent: string;
  questionOptionList?: Array<IQuestionOption>;
  value?: string | number;
  remark?: string;
}
interface IQuestionOption {
  id: number;
  optionSort: number;
  optionContent: string;
}
interface IAnswer {
  id: number;
  answerList: Array<IAnswerList>;
}
interface IAnswerList {
  id: number;
  answer: string | number;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const formState = reactive<{ data: IAppraiseData }>({
  data: { id: 0 }
});
onMounted(() => {
  setTimeout(async () => {
    await loadData();
  }, 200)
})
const loadData = async () => {
  formState.data = await getEvaluationInfo(route.query.tplId as unknown as number, route.query.assistId as unknown as number) as unknown as IAppraiseData;
}
const subEmoji = (v: string) => {
  const maxlength = 500;
  if (v.length > maxlength) {
    return v.substring(0, maxlength);
  }
  return v;
}
const onSubmit = async () => {
  if (formState.data && formState.data.questionList && formState.data.questionList.length) {
    const valid = formState.data.questionList.every(q => q.value || (typeof q.value == "number" && q.value === 0));
    if (valid) {
      const postData: IAnswer = {
        id: formState.data.id,
        answerList: []
      };
      formState.data.questionList.forEach(ques => {
        const { id, questionType, value } = ques;
        postData.answerList.push({
          id,
          answer: questionType == 3 ? subEmoji(value as string) : value
        })
      })
      await submitEvaluationInfo(postData);
      loadData();
    } else {
      Toast("请完成全部题目后提交！")
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["student-appraise", { 'bg-transparent': _unref(formState).data && _unref(formState).data.id && _unref(formState).data.taskStatus }])
  }, [
    (_unref(formState).data && _unref(formState).data.id && _unref(formState).data.taskStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formState).data.name), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(formState).data.taskStatus == 1 && !_unref(formState).data.expiration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_unref(formState).data.evaluationRemark)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(formState).data.evaluationRemark), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formState).data.questionList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["question-item text-bold", { first: index == 0 }])
              }, _toDisplayString(index + 1) + "." + _toDisplayString(item.questionContent), 3),
              (item.remark)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.remark), 1))
                : _createCommentVNode("", true),
              (item.questionType == 1)
                ? (_openBlock(), _createBlock(_unref(RadioGroup), {
                    key: 1,
                    modelValue: item.value,
                    "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.questionOptionList, (op) => {
                        return (_openBlock(), _createBlock(_unref(Radio), {
                          key: op.optionSort,
                          name: op.optionSort
                        }, {
                          icon: _withCtx((props) => [
                            _createElementVNode("img", {
                              class: "img-icon",
                              src: props.checked ? require('@/assets/student/appraise/active-radio.png') : require('@/assets/student/appraise/inactive-radio.png')
                            }, null, 8, _hoisted_9)
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(op.optionContent), 1)
                          ]),
                          _: 2
                        }, 1032, ["name"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"]))
                : (item.questionType == 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (idx) => {
                          return _createElementVNode("div", {
                            key: idx,
                            class: _normalizeClass({ 'check-square': true, 'checked': item.value == idx }),
                            onClick: ($event: any) => (item.value = idx)
                          }, _toDisplayString(idx), 11, _hoisted_11)
                        }), 64))
                      ]),
                      _hoisted_12
                    ], 64))
                  : (item.questionType == 3)
                    ? (_openBlock(), _createBlock(_unref(Field), {
                        key: 3,
                        modelValue: item.value,
                        "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                        rows: "5",
                        label: "",
                        type: "textarea",
                        maxlength: "500",
                        placeholder: "请输入",
                        "show-word-limit": "",
                        class: "textarea-wrap"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(formState).data.taskStatus == 1 && !_unref(formState).data.expiration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_unref(Button), {
            round: "",
            block: "",
            type: "primary",
            class: "btn",
            onClick: onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(formState).data.taskStatus != 1 || _unref(formState).data.expiration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_unref(formState).data.expiration)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_16,
                _hoisted_17
              ], 64))
            : _createCommentVNode("", true),
          (_unref(formState).data.taskStatus == 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_18,
                _hoisted_19
              ], 64))
            : _createCommentVNode("", true),
          (!_unref(formState).data || !_unref(formState).data.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})